import { authenticateRequest } from '@api/authenticateRequest';

interface GetFamilyEventSmsToggleStatusResponse {
  enabled: boolean;
}

export async function getFamilyEventSmsToggleStatus(): Promise<GetFamilyEventSmsToggleStatusResponse | false> {
  const response = await authenticateRequest<GetFamilyEventSmsToggleStatusResponse>({
    method: 'get',
    url: '/api/v1/admin/events/sms-toggle',
  });

  console.log('getFamilyEventSmsToggleStatus', { response });
  return response;
}

export type { GetFamilyEventSmsToggleStatusResponse };
